import 'date-fns';
import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

export default function MaterialUIPickers(props) {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  useEffect(() => {
    if(props.selectedDate){
      var date = new Date()
      var t = props.selectedDate.split(":");
      date.setHours(t[0])
      date.setMinutes(t[1])
      date.setSeconds(t[2])
      setSelectedDate(date);
    }
  }, [props.selectedDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    var time = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    props.onTimeChange(time)
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around" className="reminderpickerpopup">
        <KeyboardTimePicker
          margin="normal"
          id="time-picker"
          autoOk="false"
          label=""
          value={selectedDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change time',
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}
